import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  // DESKTOP
  container: {
    backgroundColor: theme.palette.common.white,
    borderBottom: theme.customBorders.gray300,
    padding: theme.spacing(0, 3),
    minHeight: 52,
  },
  leftSection: {
    height: '100%',
    whiteSpace: 'nowrap',
    gap: theme.spacing(2), // 16px between menu items — matches the monolith global nav
    '&.invisible': {
      opacity: 0,
    },
  },
  rightSection: {
    width: 'auto',
    // Push to the right edge so container paddingRight controls the gap
    // between these items and the fixed copilot button.
    marginLeft: 'auto',
    gap: theme.spacing(1), // 8px between icons — matches the monolith global nav
    '&.invisible': {
      opacity: 0,
    },
  },

  // MOBILE
  containerMobile: {
    backgroundColor: theme.palette.common.white,
    borderBottom: theme.customBorders.gray300,
    borderTop: theme.customBorders.gray300,
    padding: theme.spacing(5, 1.5, 1.5),
  },
  fountainLogoMobile: {
    borderRadius: 3,
    height: 32,
    width: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftSectionMobile: {
    height: '100%',
    '& > :not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  rightSectionMobile: {
    width: 'unset',
  },
}));

export default useStyles;
